import clsx from "clsx";

import {
  Loader,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "@transfr-inc/dashboard-components";
import { Button } from "@transfr-inc/dashboard-components/forms";

import { useState } from "react";
import "./roster-sync-confirm.modal.scss";

export default ({ open, enabling, onCancel, onConfirm }) => {
  const [loading, setLoading] = useState();
  const action = enabling ? "resume" : "pause";

  const onConfirmHandler = async () => {
    setLoading(true);

    try {
      await onConfirm?.();
    } finally {
      setLoading();
    }
  };

  return (
    <Modal
      open={open}
      backdropClassName="roster-sync-confirm-modal"
      onClose={onCancel}
    >
      {loading && <Loader overlay />}
      <ModalHeader
        className={clsx({ "blue-icon": enabling, "red-icon": !enabling })}
        icon={["fa-regular", enabling ? "play" : "pause"]}
        title={enabling ? "Resume Rostering" : "Pause Rostering"}
      ></ModalHeader>
      <ModalBody>
        <div>
          Are you sure you want to {action} rostering for this organization?{" "}
          {enabling
            ? "Roster syncing will resume on the next scheduled run."
            : "Roster syncing will be paused until you turn it back on."}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button onClick={onCancel}>Cancel</Button>
        <Button primary onClick={onConfirmHandler}>
          {enabling ? "Yes, Resume" : "Yes, Pause"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
